import React, { useState } from 'react';
import './App.css';
import { GROQ_API_KEY, GROQ_API_URL } from './config';
import axios from 'axios';

function App() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const sendMessage = async (e) => {
    e.preventDefault();
    if (!input.trim()) return;

    const userMessage = {
      role: 'user',
      content: input
    };

    setMessages(prev => [...prev, userMessage]);
    setInput('');
    setIsLoading(true);

    try {
      const response = await axios.post(GROQ_API_URL, {
        model: "mixtral-8x7b-32768",
        messages: [...messages, userMessage].map(msg => ({
          role: msg.role,
          content: msg.content
        })),
        temperature: 0.7,
        max_tokens: 1024,
      }, {
        headers: {
          'Authorization': `Bearer ${GROQ_API_KEY}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.data && response.data.choices && response.data.choices[0]) {
        const aiMessage = {
          role: 'assistant',
          content: response.data.choices[0].message.content
        };
        setMessages(prev => [...prev, aiMessage]);
      } else {
        throw new Error('Format respons tidak valid');
      }
    } catch (error) {
      console.error('Error detail:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });
      alert(`Terjadi kesalahan: ${error.response?.data?.error?.message || error.message}`);
    }

    setIsLoading(false);
  };

  return (
    <div className="App">
      <div className="header">
        <div className="logo">
          <img src="/logo.png" alt="Snake-Bot AI Logo" className="logo-img" />
        </div>
        <div className="logo-text">OUROBOROS AI</div>
      </div>
      <div className="hero-section">
        <h1>OUROBOROS AI Assistant</h1>
        <p>Create Your Snake, Customize Your Snake, Make Your Snake Stronger</p>
        <div className="features">
          <div className="feature">🤖 AI-Powered Automation
          Automate repetitive tasks and workflows with intelligent AI agents that learn and adapt to your business needs.</div>
          <div className="feature">🧬 Social Media Management
          Engage with your audience across platforms through AI agents that create, schedule, and manage social media content.</div>
          <div className="feature">🔒 Enterprise Security
          Deploy AI agents with enterprise-grade security and compliance measures to protect your business data.</div>
          <div className="feature">🔋 Performance Analytics
          Track and optimize your AI agents' performance with detailed analytics and insights for continuous improvement.</div>
          <div className="feature">🐍 GAME OUROBOROS WEB3</div><button className="contact-button">play (soon)</button>
        </div>
      </div>
      <div className="chat-container">
        <div className="messages">
          {messages.map((message, index) => (
            <div key={index} className={`message ${message.role}`}>
              {message.content}
            </div>
          ))}
          {isLoading && <div className="loading">AI typing...</div>}
        </div>
        <form onSubmit={sendMessage} className="input-form">
          <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Type your message..."
            disabled={isLoading}
          />
          <button type="submit" disabled={isLoading}>
            Send
          </button>
        </form>
      </div>
      <div className="hero-section">Create Your Agent
      Design your AI agent with a unique personality and capabilities tailored to your needs.</div>
      <footer className="footer" style={{ textAlign: 'center', padding: '20px', marginTop: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
        <div className="social-links" style={{ display: 'flex', gap: '15px' }}>
          <a href="https://twitter.com/ouroborosai" target="_blank" rel="noopener noreferrer">
            <img src="/twitter.jpg" alt="Twitter" className="social-logo" style={{ width: '40px', height: '40px' }} />
          </a>
          <a href="https://warpcast.com/ouroborosai" target="_blank" rel="noopener noreferrer">
            <img src="/warpcaster.jpeg" alt="Warpcast" className="social-logo" style={{ width: '40px', height: '40px' }} />
          </a>
        </div>
        © 2024 OUROBOROS AI. All rights reserved.
      </footer>
    </div>
  );
}

export default App;
